module.exports = __webpack_public_path__ + "img/verifici_valabilitate.958806ef.svg";